import { makeStyles } from '@material-ui/core/styles';
import { SOURCES } from '../../../../../constants/sources';

export default makeStyles((theme) => ({
    rootItemListProgramCardContent: {
        width: '100%',
        height: '158px',
        display: "inline-flex",
    },
    principalContainer: {
        width: props => props.hasDetail ? '288px' : '100%',
        background: props => `url(${props.backgroundImage})`,
        backgroundSize: "cover !important",
        backgroundPosition: 'center !important',
        display: "flex",
        flexDirection: "column",
    },
    dataContainer: {
        flexGrow: 2,
        padding: '16px',
    },
    expandContainer: {
        cursor: 'pointer',
        display: props => props.hasDetail ? 'block' : 'none',
        width: '40px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    iconsContainer: {
        display: props => props.hasDetail ? 'block' : 'flex',
    },
    misCursosFillSVGIcon: {
        marginRight: props => props.hasDetail ? 0 : "8px",
        fontSize: "24px",
        marginBottom: props => props.hasDetail ? "8px" : 0,
    },
    [`logoCompany${SOURCES.UERRE}`]: {
        height: '16px',
    },
    [`logoCompany${SOURCES.UNID}`]: {
        height: '17px',
    },
    name: {
        color: theme.palette.colors.gray[100],
        marginTop: "8px",
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: '-webkit-box !important',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        whiteSpace: 'normal',
    },
    priceAndMembershipContainer: {
        height: '32px',
    },
    expandSectionPOBG: {
        background: theme.palette.colors.ou.uerreBlueC3,
    },
    expandSectionLIBG: {
        background: theme.palette.colors.ou.unidBusinessBlue,
    },
    expandSectionMABG: {
        background: theme.palette.colors.ou.unidBusinessMagenta,
    },
    expandSectionBABG: {
        background: theme.palette.colors.ou.unidBusinessOrange,
    }
}));